module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BH - Bahrain.3a2cb3c5.svg";